import { AttendanceRecord, AttendanceRecordInsert } from "../../types/attendance";
import { supabase } from "../supabase";

export const createAttendance = async (records: AttendanceRecordInsert[]) => {
  const { data, error } = await supabase
    .from("attendance_records")
    .upsert(records, { onConflict: "student_id,date" });
  return { data, error };
};

export const getAttendanceByDate = async (
  schoolId: string,
  date: string,
): Promise<{ data: AttendanceRecord[] | null; error: unknown }> => {
  const { data, error } = await supabase
    .from("attendance_records")
    .select("*")
    .eq("school_id", schoolId)
    .eq("date", date);

  return { data: data as AttendanceRecord[] | null, error };
};

export async function updateAttendance(id: string, status: "present" | "absent") {
  const { data, error } = await supabase.from("attendance_records").update({ status }).eq("id", id);
  return { data, error };
}

export async function deleteAttendance(id: string) {
  const { error } = await supabase.from("attendance_records").delete().eq("id", id);
  return { error };
}

export async function getAttendanceByStudent(
  schoolId: string,
  studentId: string,
): Promise<AttendanceRecord[]> {
  const { data, error } = await supabase
    .from("attendance_records")
    .select("*")
    .eq("school_id", schoolId)
    .eq("student_id", studentId)
    .order("date", { ascending: false });

  if (error) throw error;
  return (data ?? []) as AttendanceRecord[];
}

export async function deleteAttendanceByDate(schoolId: string, date: string) {
  const { error } = await supabase
    .from("attendance_records")
    .delete()
    .eq("school_id", schoolId)
    .eq("date", date);
  return { error };
}
